import React from 'react';
import styled from 'styled-components';

import { toCssSelector } from '@candu-ai/stylesheet/utils';
import { formatCypressProps } from 'commons/utils';
import Node from 'craft/components/Node';
import { BuiltInComponents } from 'craft/constants';
import { AtomicText } from 'craft/resolvers/AtomicText';
import { Resolver } from 'craft/types';

// base button representation
export const FormSubmitButtonDiv = styled.div`
  background-color: #6310e5;
  border: 1px solid #6310e5;
  color: #ffffff;
  min-height: 2em;
  min-width: 6em;
  font-size: 1em;
  font-weight: 600;
  white-space: nowrap;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  opacity: 1;
  border-radius: 0.25em;
`;

interface Props {
  color: string;
  childrenString: string;
  size?: string;
  outline?: string;
}

/**
 * This has a lot in common with our regular button, implementation is mostly copied from there
 * but I expect it to diverge as we're more restrictive here
 */
export const FormSubmitButton: Resolver = ({ color, outline, childrenString, size }: Props) => {
  const colorMatchedVariant = color === 'primary' ? 'base' : color;
  const appearanceStyle = outline === 'light' ? '_light' : '';

  const buttonVariant = {
    variant: `${colorMatchedVariant}${appearanceStyle}` || 'base',
  };
  const sssClassname = toCssSelector('button', {
    variant: buttonVariant,
    output: 'html',
  });

  return (
    <Node
      data-atomictext-node
      is={FormSubmitButtonDiv}
      css={{
        display: 'inline-block',
      }}
      color={color}
      size={size}
      light={outline === 'light'}
      data-cy-props={formatCypressProps({ outline, size, color })}
      className={sssClassname}
    >
      <AtomicText data-cy="node-button-title" childrenString={childrenString} />
    </Node>
  );
};

FormSubmitButton.craft = {
  displayName: 'Form: Submit',
  name: BuiltInComponents.FormSubmitButton,
  defaultProps: {
    outline: 'solid',
    size: 'md',
    color: 'primary',
  },
  rules: {
    canDrag: () => false,
    canDelete: () => true,
    canDrop: () => false,
  },
};

FormSubmitButton.toolbox = {};

FormSubmitButton.selectedToolbar = {};
